import React from 'react';
import { Container } from 'react-bootstrap';
import '../print.css';

const MovimentiMagazzinoPrint = ({ movimenti, datiAzienda }) => {
    if (!movimenti || !datiAzienda) {
        return (
            <Container className="mt-5">
                <p>Dati per la stampa non disponibili.</p>
            </Container>
        );
    }

    return (
        <div id="printable-area" className="landscape-page">
            <div className="print-container">
                <header className="print-header">
                    <div className="company-details">
                        {datiAzienda.logo_url && (
                            <img
                                src={`${process.env.REACT_APP_STATIC_FILES_BASE_URL}${datiAzienda.logo_url}`}
                                alt="Logo Azienda"
                                style={{ maxHeight: '150px', maxWidth: '150px', marginRight: '20px', objectFit: 'contain' }}
                            />
                        )}
                    </div>
                    <div className="print-info">
                        <p><strong>Data di Stampa:</strong> {new Date().toLocaleDateString()}</p>
                    </div>
                </header>

                <main>
                    <h2 className="document-title">Report Movimenti di Magazzino</h2>
                    <table className="table table-striped table-bordered table-hover table-sm print-table non-wrapping-print-table">
                        <thead>
                            <tr style={{ whiteSpace: 'nowrap' }}>
                                <th style={{ height: '20px', overflow: 'hidden' }}>Prodotto ID</th>
                                <th style={{ height: '20px', overflow: 'hidden' }}>Titolo Prodotto</th>
                                <th style={{ height: '20px', overflow: 'hidden' }}>Tipo Movimento</th>
                                <th style={{ height: '20px', overflow: 'hidden' }}>Quantità</th>
                                <th style={{ height: '20px', overflow: 'hidden' }}>Data Movimento</th>
                                <th style={{ height: '20px', overflow: 'hidden' }}>Descrizione</th>
                            </tr>
                        </thead>
                        <tbody>
                            {movimenti.map(movimento => (
                                <tr key={movimento.id} style={{ height: '20px', whiteSpace: 'nowrap' }}>
                                    <td style={{ verticalAlign: 'middle', overflow: 'hidden' }}>{movimento.prodotto_id}</td>
                                    <td style={{ verticalAlign: 'middle', overflow: 'hidden' }}>{movimento.titolo_prodotto}</td>
                                    <td style={{ verticalAlign: 'middle', overflow: 'hidden' }}>{movimento.tipo_movimento}</td>
                                    <td style={{ verticalAlign: 'middle', overflow: 'hidden' }}>{movimento.quantita}</td>
                                    <td style={{ verticalAlign: 'middle', overflow: 'hidden' }}>{new Date(movimento.data_movimento).toLocaleDateString()}</td>
                                    <td style={{ verticalAlign: 'middle', overflow: 'hidden' }}>{movimento.descrizione}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </main>

                <footer className="print-footer">
                    <p>{datiAzienda.denominazione} - {datiAzienda.indirizzo} - {datiAzienda.cap} {datiAzienda.citta} ({datiAzienda.provincia}) - P.IVA {datiAzienda.piva}</p>
                    <p>Email: {datiAzienda.email} - Tel: {datiAzienda.tel}</p>
                </footer>
            </div>
        </div>
    );
};

export default MovimentiMagazzinoPrint;